// extracted by mini-css-extract-plugin
module.exports = {"page":"B","modal":"C","actions":"D","step":"E","logos":"F","primary":"G","disabled":"H","cancel":"I","bodyOpen":"J","primeLogo":"K","vipLogo":"L","plus":"M"};